import { PROFILE_TYPES } from '@/utils/enums';

export default [
    {
        path: '/affiliate',
        component: () => import('@/views/affiliate'),
        name: 'affiliate.home',
        meta: { auth: true },
    },
    {
        path: '/affiliate/dash',
        component: () => import('@/views/dash'),
        name: 'affiliate.dash',
        meta: { auth: true, allowRoles: [PROFILE_TYPES.AFFILIATE] },
        beforeEnter: (to, from, next) => {
            to.query = { ...to.query, partner_type: PROFILE_TYPES.AFFILIATE };
            next();
        },
    },
];
